package uz.ferro.erp

const val KEY_AUTH_TOKEN = "auth_token"
const val KEY_ROLE = "role"
const val KEY_USER = "user"
const val KEY_USER_ID = "userId"
const val KEY_LANGUAGE = "language"

object Const {

    const val PARAM_HISTORY = "history"
    const val VALUE_NO_BACK = "noBack"
}

